import { Injectable } from '@angular/core';
import { AuthLoginResponse } from '../../domain/dto';
import { Menu, Submenu } from '../../domain/model/menu.model';

@Injectable({ providedIn: 'root' })
export class AuthMapper {
  toDomain(apiResponse: AuthLoginResponse): AuthLoginResponse {
    return {
      profile: {
        name: apiResponse?.profile?.name ?? '',
        role: apiResponse?.profile?.role ?? '',
        menu: this.normalizeMenus(apiResponse?.profile?.menu),
      },
    };
  }

  private normalizeMenus(menus?: Menu[]): Menu[] {
    if (!Array.isArray(menus)) {
      return [];
    }

    return menus.map((menu) => ({
      icon: menu?.icon ?? '',
      url: menu?.url ?? '',
      title: menu?.title ?? '',
      isReadOnly: !!menu?.isReadOnly,
      submenus: this.normalizeSubmenus(menu?.submenus),
    }));
  }

  private normalizeSubmenus(submenus?: Submenu[]): Submenu[] {
    if (!Array.isArray(submenus)) {
      return [];
    }

    return submenus.map((submenu) => ({
      icon: submenu?.icon ?? '',
      url: submenu?.url ?? '',
      title: submenu?.title ?? '',
      isReadOnly: !!submenu?.isReadOnly,
    }));
  }

}


